import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ErrorMessage } from 'ui/shared/messages';

export type Props = {
    errorMessage: string;
};

export const VerifyResetPasswordExpired = ({ errorMessage }: Props) => {
    const { t } = useTranslation();

    return (
        <div
            id="verify-reset-password-expired"
            className={ `ui grid form error` }
        >
            <div className="column">
                <ErrorMessage message={ errorMessage }/>
                <Link
                    className="ui primary submit button"
                    to="/reset-password"
                >
                    <div className="visible content"> { t('COMMAND.GET_NEW_LINK') }</div>
                </Link>
            </div>
        </div>
    );
};
